export default "__VITE_ASSET__CVkNGNPs__"